import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext.js';
import { Layout } from './components/Layout.js';
import { UpdatePrompt } from './components/UpdatePrompt.js';
import { LoginPage } from './pages/LoginPage.js';
import { TodayPage } from './pages/TodayPage.js';
import { TrendsPage } from './pages/TrendsPage.js';
import { AddPage } from './pages/AddPage.js';
import { RecipesPage } from './pages/RecipesPage.js';
import { WeightPage } from './pages/WeightPage.js';
import { SettingsPage } from './pages/SettingsPage.js';

export function App(): JSX.Element {
  const { user, loading } = useAuth();

  // Hold the shell until the stored session has been checked, otherwise a
  // logged-in user sees the login screen flash on every cold start.
  if (loading) {
    return (
      <div className="center-screen">
        <div className="spinner" role="status" aria-label="Lädt" />
      </div>
    );
  }

  if (!user) {
    return (
      <>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <UpdatePrompt />
      </>
    );
  }

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<TodayPage />} />
          <Route path="/trends" element={<TrendsPage />} />
          <Route path="/add" element={<AddPage />} />
          <Route path="/recipes" element={<RecipesPage />} />
          <Route path="/weight" element={<WeightPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
      <UpdatePrompt />
    </>
  );
}
